/**
 * Service générique pour tous les appels à l'API CITRA générée (client OpenAPI).
 * Centralise la configuration et la gestion des instances d'API générées.
 *
 * Le client est généré par openapi-generator (`npm run generate-api`) à partir
 * du sous-module `openapi-spec` dans `src/api/generated`.
 *
 * Usage :
 *   import { getDefaultApi } from '../services/ChinookApiService';
 *   const { data } = await getDefaultApi().rafraichirToken();
 */
// eslint-disable-next-line import/no-unresolved
import { DefaultApi, Configuration } from '../api/generated';
import apiAxiosInstance from '../api/apiAxiosInstance';
import { getToken } from './ResourcesService';

// Base path de l'API CITRA (ex: https://.../v1)
const BASE_PATH = () => `${process.env.REACT_APP_CITRA_URL}/v1`;

class ChinookApiService {
  static instance = null;

  static getInstance() {
    if (!ChinookApiService.instance) {
      ChinookApiService.instance = new ChinookApiService();
    }
    return ChinookApiService.instance;
  }

  /**
   * Construit la configuration Axios/OpenAPI avec le token courant.
   * Recréée à chaque appel pour toujours disposer d'un token à jour.
   */
  getConfiguration() {
    const token = getToken();

    return new Configuration({
      basePath: BASE_PATH(),
      accessToken: token || '',
      baseOptions: {
        headers: {
          Authorization: token ? `Bearer ${token}` : ''
        }
      }
    });
  }

  /**
   * Retourne une instance de DefaultApi.
   * On passe apiAxiosInstance pour bénéficier de la gestion centralisée du token.
   */
  getDefaultApi() {
    return new DefaultApi(this.getConfiguration(), undefined, apiAxiosInstance);
  }
}

export const chinookApiService = ChinookApiService.getInstance();

// Helpers pour un usage simplifié dans les services
export const getDefaultApi = () => chinookApiService.getDefaultApi();

